var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-duanshi"},[_c('div',{staticClass:"u-list"},_vm._l((_vm.pics),function(pic,i){return _c('img',{key:i,staticClass:"u-img",class:{'show':_vm.activeIndex == i},attrs:{"src":_vm.buildImgUrl(pic)}})}),0),_c('div',{staticClass:"u-toggle",class:{'show':_vm.isMultiple},on:{"click":_vm.toggleHandle}},[_vm._v("切换")])])
}
var staticRenderFns = []

export { render, staticRenderFns }